// extracted by css-extract-rspack-plugin
export default {"icon":"fk6zU","apple":"Nt3Gm"};